export default function Logo(props: { size?: number }) {
  const size = props.size ?? 36
  return (
    <div className="flex items-center gap-3">
      <img
        src="/assets/ic_splash_logo.png"
        alt="Soulon logo"
        style={{ width: size, height: size }}
        className="rounded-lg border border-white/10 bg-black/30 object-contain"
        loading="eager"
      />
      <div className="leading-tight">
        <div className="text-sm font-semibold tracking-wide text-white">Soulon</div>
        <div className="text-xs text-white/50">Memory · Identity · Payments</div>
      </div>
    </div>
  )
}

